import { defineComponent as _defineComponent } from 'vue'
import { DataInstance, Userspaces, Meetings, InviteLinks } from '@busy-human/opt-library'
import { ref, computed } from 'vue'

import TextField from "@/components/text-area.vue"
import { Moment } from 'moment';
type Props = {
    invite: InviteLinks.Model
    request: Meetings.Model
    person: DataInstance<Userspaces.Model>
}
type Emits = {
    (e: 'update:request', request: Meetings.Model): void
    (e: 'previous'): void
    (e: 'progress'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'note-to-sender',
  props: {
    invite: null,
    request: null,
    person: null
  },
  emits: ["update:request", "previous", "progress"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'update:request', request: Meetings.Model): void
    (e: 'previous'): void
    (e: 'progress'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    invite: InviteLinks.Model
    request: Meetings.Model
    person: DataInstance<Userspaces.Model>
}


var moment = require('moment'); // require




const message = ref('')

const previous = () => {
    emit('previous');
}
const proceed = () => {
    let tmpMeeting = props.request
    tmpMeeting.receiversNote = message.value
    emit('update:request', tmpMeeting)
    emit('progress');
}



const __returned__ = { moment, props, emit, message, previous, proceed, DataInstance, Userspaces, Meetings, InviteLinks, ref, computed, TextField, Moment }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})